interface ReviewAttributesDTO {
  title: string;
  body: string;
  rating: number;
  source: string;
  origin: string;
  user_name: string;
  user_id: string;
  user_pic: string;
  verified_purchase: number;
  votes: number;
  positive_votes: number;
  negative_votes: number;
  variant_name: string;
  variant_sku: string;
  created_at: string;
  status: string;
  status_reason: string;
  article_id: string;
  parent_article_id: string;
  article_title: string;
  company_industry: string;
  company_size: string;
  brand_id: string;
  brand_response: string;
  brand_author: string;
  brand_date: string | null;
  brand_edit: number;
}

interface RatingAttributesDTO {
  created_at: string;
  updated_at: string;
  total_opinions: number;
  average_rating: string;
  rating_count: {
    '1': number;
    '2': number;
    '3': number;
    '4': number;
    '5': number;
  }
}

interface RatingDTO {
  type: string;
  rating_id: string;
  average_rating: number;
  parent_article_id: string;
  attributes: RatingAttributesDTO
}

interface ReviewDTO {
  type: string;
  id: string;
  attributes: ReviewAttributesDTO;
}

interface LinksDTO {
  first: string;
  last: string;
  prev: string | null;
  next: string;
}

interface MetaLinkDTO {
  url: string | null;
  label: string;
  active: boolean;
}

interface MetaDTO {
  current_page: number;
  from: number;
  last_page: number;
  links: MetaLinkDTO[];
  path: string;
  per_page: number;
  to: number;
  total: number;
}

export interface ReviewResponseDTO {
  data: ReviewDTO[];
  links: LinksDTO;
  meta: MetaDTO;
}

export interface RatingResponseDTO {
  data: RatingDTO;
}

interface ReviewsQueryParamsDTO {
  'sort': string;
  'page[number]': number;
  'page[size]'?: number;
  'filter[article_id]': string;
  'filter[status]': 'active';
  'filter[search]'?: string;
}

interface ArticleReviewByUserDTO {
  'page[number]': 1;
  'page[size]': 1;
  'filter[article_id]': string;
  'filter[status]': 'active';
  'filter[user_id]': string;
}

interface MyReviewsQueryParamsDTO {
  'sort': string;
  'page[number]': number;
  'page[size]'?: number;
  'filter[user_id]': string;
  'filter[status]': 'active';
  'filter[search]'?: string;
}

/**
 * @deprecated
 */
export interface NewSingleReviewRating {
  vote: number;
}

export interface VoteReviewDTO {
  vote: number;
  userId: string;
  reviewId: string;
}

export interface ReviewVotedDTO {
  reviewId: string
}

export interface ICreateReviewDTO {
  user_id: string
  rating: number
  title: string
  body: string
  article_id: string
  article_title: string
  variant_sku: string
  variant_name: string
  user_name: string
  brand_id: string
  source: 'cp'
}

const reviewsPaths = {
  all: '/reviews/reviews' as const,
  postVote: (reviewId: string) => `/reviews/reviews/${reviewId}/votes` as const,
  getVote: (reviewId: string) => `/reviews/reviews/${reviewId}/vote` as const,
  getRating: (productId: string) => `/reviews/reviews/${productId}/rating` as const,
};


export const getReviewsByAPI = (params: ReviewsQueryParamsDTO | ArticleReviewByUserDTO | MyReviewsQueryParamsDTO) => {
  const options = {
    params,
    withoutAuthorization: true,
    useMS: true,
  };
  return $cpFetch<ReviewResponseDTO>(reviewsPaths.all, options);
};

export const voteReviewByAPI = (params: VoteReviewDTO) => {
  const options = {
    method: 'POST',
    body: {
      vote: params.vote,
      user_id: params.userId,
    },
    withoutAuthorization: true,
    useMS: true,
  };
  return $cpFetch<unknown>(reviewsPaths.postVote(params.reviewId), options);
};


export const createReview = async (review: ICreateReviewDTO) => {
  const options = {
    method: 'POST',
    body: review,
    withoutAuthorization: true,
    removeWebMobileParam: true,
    useMS: true,
  };
  return await $cpFetch(reviewsPaths.all, options);
};

export const getRating = async (idProduct: string) => {
  const options = {
    method: 'GET',
    withoutAuthorization: true,
    removeWebMobileParam: true,
    useMS: true,
  };
  return await $cpFetch<RatingResponseDTO>(reviewsPaths.getRating(idProduct), options);
};
